export default function (props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle fillOpacity=".421" fill="#FFF" cx="22" cy="22" r="17" />
                <g stroke="#222" strokeLinecap="round" strokeWidth="2">
                    <path d="M21.914 17.171a5.914 5.914 0 1 0 4.605 2.203" />
                    <path strokeLinejoin="round" d="m20.258 15 2.512 2.261-2.261 2.512" />
                </g>
            </g>
        </svg>
    );
}
